'use client';

import { usePathname } from 'next/navigation';
import * as React from 'react';

import { TourDriver } from './tour-driver';

// Surfaces where the tour must never draw: auth/onboarding flows (the fork
// page owns the tour there), public viewers, and internal/dev routes.
const SUPPRESSED_PREFIXES = [
  '/welcome',
  '/sign-in',
  '/design',
  '/internal',
  '/published',
  '/join',
  '/accept-invitation',
  '/mobile-unavailable',
];

/**
 * Mounts the tour driver above every routed surface (and above RouteFade —
 * the driver's coachmarks portal to <body>, so no transformed ancestor can
 * capture their fixed positioning).
 */
export function TourProvider({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const suppressed = SUPPRESSED_PREFIXES.some((prefix) =>
    pathname.startsWith(prefix)
  );
  return (
    <>
      {children}
      {suppressed ? null : <TourDriver />}
    </>
  );
}
